// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__8fnV6","modalTitle":"Modal_modalTitle__a5x9R","modalButtons":"Modal_modalButtons__iH9eN","modalButton":"Modal_modalButton__npAyH"};